<template>
  <b-container class="mt-5">
    <div v-if="showScreener">
          
      <div class="d-none d-md-block">    
      <b-row class="progress-row">
        <b-col>
          <ul class="progressbar">
            <li v-bind:class="{ active: current_step >= i }" v-for="i in max_step" :key="i">{{steps[i-1]}}</li>
          </ul>
        </b-col>
      </b-row>
      </div>
 
       <div class="d-block d-md-none">
          <div :class="['mobile-step',(current_step == i ? 'active' : null), (current_step > i ? 'completed' : null)]" v-for="i in max_step" :key="i">{{steps[i-1]}}</div>
      </div>
 

      <b-card v-if="current_step == 1" class="card-style">
        <h4 class="card-title" tabindex="0">Contact Info</h4>
        <b-row align-v="start" class="text-left">
          <b-col>
            <h4 tabindex="0">Please enter your contact information.</h4>
            <p tabindex="0">
              By using this service, you agree to allow First Five SC and its partners to collect and process your information in order to connect you with relevant services. 
              Your privacy is important to us, and your data will be handled in accordance with our Privacy Policy.
            </p>
          </b-col>
        </b-row>
        <b-form @submit="contactInfoSubmit">
          
          <b-form-group
            label="Parent Or Guardian Name"
            label-sr-only
            label-for="name"
          >
            <label class="sr-only" for="name">Parent Or Guardian Name</label>
            <b-form-input
              id="name"
              v-model="name"
              placeholder="Parent or Guardian Name"
              required
            ></b-form-input>
          </b-form-group>
          <b-form-group
            label="Email Address"
            label-sr-only
            label-for="email"
          >
          <label class="sr-only" for="email">Email Address</label>
            <b-form-input
              id="email"
              v-model="email"
              placeholder="Email Address"
              type="email"
              required
            ></b-form-input>
          </b-form-group>
          <b-form-group
            label="Cell Phone"
            label-sr-only
            label-for="phone"
          >
          <label class="sr-only" for="phone">Cell Phone</label>
            <b-form-input
              id="phone"
              v-model="phone"
              placeholder="Cell Phone"
              required
            ></b-form-input>
          </b-form-group>
          <b-form-group 
            label="How did you hear about First Five SC?"
            label-for="hear-radio"
          >
            <b-form-radio-group
              id="hear-radio"
              v-model="hearSelected"
              :options="hearOptions"
              name="hear-radio-options"
              required
              stacked
            >
            </b-form-radio-group>
            <b-form-input
              v-if="hearSelected == 'sign'"
              id="hearSign"
              v-model="hearOther"
              placeholder="Where?"
              style="margin-top:20px;width:33%;"
            ></b-form-input>

            <b-form-input
              v-if="hearSelected == 'other'"
              id="hearOther"
              v-model="hearOther"
              placeholder="Other"
              style="margin-top:20px;width:33%;"
            ></b-form-input>
          </b-form-group>
          <b-form-group>
            <b-form-checkbox id="checkbox-1"
                                    v-model="status"
                                    name="checkbox-1"
                                    value="accepted"
                                    unchecked-value="not_accepted"
                                    required>Yes, I consent to the collection and/or usage by SC First Steps or our partners of your personal information as referred to or otherwise stated in the <a target="_blank" href="https://first5sc.org/privacy-policy">Privacy Policy and Terms of Use.</a></b-form-checkbox>
          </b-form-group>
          <b-form-group>
            <b-form-checkbox id="checkbox-2"
                             v-model="textConsent"
                             name="checkbox-2"
                             value="true"
                             unchecked-value="false">
                             Yes, I would like to receive text reminders from First Five SC.
                            </b-form-checkbox>
          </b-form-group>
          <b-button class="float-right" type="submit" pill variant="primary"
            >Next</b-button
          >
        </b-form>
      </b-card>
      <b-card
        v-if="current_step == 2"
        class="card-style"
      >
        <h4 class="card-title" tabindex="0">Child's Birthday</h4>
        <b-row align-v="start" class="text-left">
          <b-col>
            <h4 tabindex="0">Please enter your child's birthday or your expected due date.</h4>
            <p tabindex="0">
              To determine eligibility for multiple children, complete this form and then you will have the opportunity to complete for another child.
            </p>
          </b-col>
        </b-row>
        <b-form @submit="birthdaySubmit">
          <b-form-group
            label="Birthday Month"
            label-sr-only
          >
          <label class="sr-only">Birthday Month</label>
            <b-form-select
              v-model="birthdayMonth"
              :options="birthday_months"
              required
            ></b-form-select>
          </b-form-group>
          <b-form-group
            label="Birthday Day"
            label-sr-only
          >
          <label class="sr-only">Birthday Day</label>
            <b-form-select
              v-model="birthdayDay"
              :options="birthday_days"
              required
            ></b-form-select>
          </b-form-group>
          <b-form-group
            label="Birthday Year"
            label-sr-only
          >
          <label class="sr-only">Birthday Year</label>
            <b-form-select
              v-model="birthdayYear"
              :options="birthday_years"
              required
            ></b-form-select>
          </b-form-group>
          <p v-if="invalidBirthDate" class="error">
            You have entered an invalid birth date. Please enter the correct date.
          </p>
          <br />
          <b-button @click="onClickBack" class="float-left" pill variant="danger"
            >Back</b-button
          >
          <b-button class="float-right" type="submit" pill variant="primary"
            >Next</b-button
          >
        </b-form>
      </b-card>
      <b-card v-if="current_step == 3" class="card-style">
        <h4 class="card-title" tabindex="0">Address</h4>
        <b-row align-v="start" class="text-left">
          <b-col>
            <h4 tabindex="0">Please enter your home address.</h4>
            <p tabindex="0">
              Eligibility in some programs is dependent on your home address.<br/>
              Please select address from the dropdown below to proceed. 
            </p>
          </b-col>
        </b-row>
        <b-form-group
          label="Address"
          label-for="map"
          label-sr-only
        >
        <label class="sr-only" for="map">Address</label>
          <vue-google-autocomplete
          ref="addressTo"
          id="map"
          classname="form-control"
          placeholder="Start typing"
          v-on:placechanged="getAddressData"
          :rules="[rules.required]"
          :country="['us']"
          :enable-geolocation=true
          :value="getSavedAddress"
          style="margin-bottom:10px;"
          v-on:inputChange="addressInputChanged"
        >
        </vue-google-autocomplete>
        <p v-if="invalidAddress" class="error">
            You have entered an invalid address. Please pick an address from the drop down as you type.
          </p>
        </b-form-group>
        <b-form-group
          label="Apartment Number"
          label-for="apartment"
          label-sr-only
        >
        <label class="sr-only" for="apartment">Apartment Number</label>
          <b-form-input
            id="apartment"
            v-model="apartment"
            placeholder="Apartment Number"
            type="text"
          ></b-form-input>
        </b-form-group>
        <b-button @click="onClickBack" class="float-left" pill variant="danger"
          >Back</b-button
        >
        <b-button
          @click="addressSubmit"
          class="float-right"
          type="submit"
          pill
          variant="primary"
          >Next</b-button
        >

        <div id="districtMap"></div>
      </b-card>
      <b-card
        v-if="current_step == 4"
        class="card-style"
      >
        <h4 class="card-title" tabindex="0">Additional Criteria</h4>
        <h4 class="pb-4" tabindex="0">Select all that may apply:</h4>
        <b-form @submit="specialCircumstancesSubmit">
          <b-form-group v-if="criteria.filter(x => x.Category == 'Household Circumstances').length > 0" 
            label="Household Circumstances"
          >
            <b-form-checkbox-group
              id="criteria1"
              v-model="selectedCriteria"
              :options="criteria.filter(x => x.Category == 'Household Circumstances')"
              stacked
              class="text-left"
            >
            </b-form-checkbox-group>
          </b-form-group>
          <b-form-group v-if="criteria.filter(x => x.Category == 'Developmental Delays and Special Needs').length > 0" label="Developmental Delays and Special Needs">
            <b-form-checkbox-group
              id="criteria2"
              v-model="selectedCriteria"
              :options="criteria.filter(x => x.Category == 'Developmental Delays and Special Needs')"
              stacked
              class="text-left"
            >
            </b-form-checkbox-group>
          </b-form-group>
          <b-form-group v-if="criteria.filter(x => x.Category == 'Government Benefits').length > 0" label="Are you already eligible or receiving government benefits?">
            <b-form-checkbox-group
              id="criteria3"
              v-model="selectedCriteria"
              :options="criteria.filter(x => x.Category == 'Government Benefits')"
              stacked
              class="text-left"
            >
            </b-form-checkbox-group>
          </b-form-group>
          <b-form-group v-if="criteria.filter(x => x.Category == 'High Risk Pregnancy').length > 0" label="High Risk Pregnancy">
            <b-form-checkbox-group
              id="criteria4"
              v-model="selectedCriteria"
              :options="criteria.filter(x => x.Category == 'High Risk Pregnancy')"
              stacked
              class="text-left"
            >
            </b-form-checkbox-group>
          </b-form-group>
          <b-form-group v-if="criteria.filter(x => x.Category == 'Adoption / Foster Care').length > 0" label="Adoption / Foster Care">
            <b-form-checkbox-group
              id="criteria5"
              v-model="selectedCriteria"
              :options="criteria.filter(x => x.Category == 'Adoption / Foster Care')"
              stacked
              class="text-left"
            >
            </b-form-checkbox-group>
          </b-form-group>
          <b-form-group v-if="criteria.filter(x => x.Category == 'Abuse / Neglect').length > 0" label="Abuse / Neglect">
            <b-form-checkbox-group
              id="criteria6"
              v-model="selectedCriteria"
              :options="criteria.filter(x => x.Category == 'Abuse / Neglect')"
              stacked
              class="text-left"
            >
            </b-form-checkbox-group>
          </b-form-group>
          <b-form-group v-if="criteria.filter(x => x.Category == 'Additional Optional Household Circumstances').length > 0" label="Additional Optional Household Circumstances">
            <b-form-checkbox-group
              id="criteria7"
              v-model="selectedCriteria"
              :options="criteria.filter(x => x.Category == 'Additional Optional Household Circumstances')"
              stacked
              class="text-left"
            >
            </b-form-checkbox-group>
          </b-form-group>
          <b-button @click="onClickBack" class="float-left" pill variant="danger"
            >Back</b-button
          >
          <b-button class="float-right" type="submit" pill variant="primary"
            >Next</b-button
          >
        </b-form>
      </b-card>
      <b-card
          v-if="current_step == 5"
          class="card-style text-left"
      >
          <h4 class="card-title" tabindex="0">Income</h4>
          <b-card-text>
              Please enter your family's size including yourself, and your family's annual gross income (before taxes are taken out).
          </b-card-text>
          <b-form @submit="incomeSubmit">
              <b-form-group label="Persons in Household">
                  <b-form-select
                      v-model="peopleInHousehold"
                      :options="people_in_house_options"
                      required
                  >
                  </b-form-select>
              </b-form-group>
              <b-form-group label="Annual Income">
                  <CurrencyInput class="form-control" v-model="income" :options="currencyOptions" required></CurrencyInput>
              </b-form-group>
              <b-button @click="onClickBack" class="float-left" pill variant="danger"
              >Back</b-button
              >
              <b-button class="float-right" type="submit" pill variant="primary"
              >Next</b-button
              >
          </b-form>
      </b-card>
    </div>
    <div v-else>
     
      <section style="background:white;" class="programs-services py-2" v-if="anyEligible && !categoryView && !programView">
        
        <div v-if="programs.filter(x => !x.Ineligible && x.ShowInCommonApplication).length > 0">
          <h3 class="text-center pb-5">Based on the information you entered, your child may be eligible for the following 
            programs that you can <a target="_blank" :href="commonAppUrl">apply</a> for on First Five SC:</h3>
          <b-container>
            <div class="md-border d-none d-md-block"></div> 
            <b-row>
              <b-col class="mb-4" md="6" v-for="program in programs.filter(x => !x.Ineligible  && x.ShowInCommonApplication)" :key="program.ProgramId">
                <a :href="program.ProgramPageUrl">
                  <span class="program-name">{{program.Name}}</span>
                  <span class="learn-more">Learn More <i class="fas fa-chevron-circle-right"></i></span>
                </a>
                <p>{{program.ProgramShortDescription}}</p>
              </b-col>
            </b-row>     
          </b-container>
          <div class="questions-headline pb-5" style="background: none;">
            <div class="container">
                    <a target="_blank" :href="commonAppUrl">
                        <h2 class="section-headline" style="margin: 0;">Apply Now on First Five SC</h2>
                        <p>Apply now for all the programs above in one place.</p>


                        <div class="circle-button button green-button">
                            <i class="fas fa-chevron-right"></i>
                        </div>
                  
                    </a>
            </div>
        </div>
        </div>
        <div v-if="programs.filter(x => !x.Ineligible && !x.ShowInCommonApplication).length > 0">
          <h3 class="text-center pt-5">Based on the information you entered, <br/> your child may also be eligible for the following programs:</h3>
          <p class="text-center">For information on how to apply for these programs click "learn more" under each program.</p>
          <b-container>
            <div class="md-border d-none d-md-block"></div> 
            <b-row >
              <b-col class="mb-4" md="6" v-for="program in programs.filter(x => !x.Ineligible  && !x.ShowInCommonApplication)" :key="program.ProgramId">
                <a :href="program.ProgramPageUrl">
                  <span class="program-name">{{program.Name}}</span>
                  <span class="learn-more">Learn More <i class="fas fa-chevron-circle-right"></i></span>
                </a>
                <p>{{program.ProgramShortDescription}}</p>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </section>
      <section style="background:white;" class="programs-services py-5" v-else-if="anyEligible && !programView && categoryView">
        <div v-if="programs.filter(x => !x.Ineligible && x.ShowInCommonApplication && x.ProgramCategory == categoryView).length > 0">
          <h3 class="text-center pb-5">Based on the information you entered, your child may be eligible for the following 
            programs in {{categoryView}} that you can <a target="_blank" :href="commonAppUrl">apply</a> for on First Five SC:</h3>
          <div v-if="programs.filter(x => !x.Ineligible && x.ShowInCommonApplication && x.ProgramCategory == categoryView).length > 0">
            <b-container>
              <div class="md-border d-none d-md-block"></div> 
              <b-row>
                <b-col class="mb-4" md="6" v-for="program in programs.filter(x => !x.Ineligible  && x.ShowInCommonApplication && x.ProgramCategory == categoryView)" :key="program.ProgramId">
                  <a :href="program.ProgramPageUrl">
                    <span class="program-name">{{program.Name}}</span>
                    <span class="learn-more">Learn More <i class="fas fa-chevron-circle-right"></i></span>
                  </a>
                  <p>{{program.ProgramShortDescription}}</p>
                </b-col>
              </b-row>     
            </b-container>
            <div class="questions-headline pb-5" style="background: none;">
            <div class="container">
                    <a :href="commonAppUrl">
                        <h2 class="section-headline" style="margin: 0;">Apply Now on First Five SC</h2>
                        <p>Apply now for all the programs above in one place.</p>


                        <div class="circle-button button green-button">
                            <i class="fas fa-chevron-right"></i>
                        </div>
                  
                    </a>
            </div>
        </div>
          </div>
          <div v-if="programs.filter(x => !x.Ineligible && !x.ShowInCommonApplication && x.ProgramCategory == categoryView).length > 0">
            <h3 class="text-center pt-5">Based on the information you entered, <br/> your child may also be eligible for the following programs in {{categoryView}}:</h3>
          <p class="text-center">For information on how to apply for these programs click "learn more" under each program.</p>
            <b-container>
              <div class="md-border d-none d-md-block"></div> 
              <b-row >
                <b-col class="mb-4" md="6" v-for="program in programs.filter(x => !x.Ineligible  && !x.ShowInCommonApplication)" :key="program.ProgramId">
                  <a :href="program.ProgramPageUrl">
                    <span class="program-name">{{program.Name}}</span>
                    <span class="learn-more">Learn More <i class="fas fa-chevron-circle-right"></i></span>
                  </a>
                  <p>{{program.ProgramShortDescription}}</p>
                </b-col>
              </b-row>
            </b-container>
          </div>
        </div>
        <div v-else>
          <h3 class="text-center">Based on the information you entered, you may not be eligible for any programs in {{categoryView}}</h3>
        </div>
        <div v-if="programs.filter(x => !x.Ineligible && x.ProgramCategory != categoryView).length > 0">
          <div v-if="programs.filter(x => !x.Ineligible && x.ShowInCommonApplication && x.ProgramCategory != categoryView).length > 0">
            <h3 class="text-center pb-5">Based on the information you entered, your child may be eligible for the following 
            programs that you can <a target="_blank" :href="commonAppUrl">apply</a> for on First Five SC:</h3>
            <b-container>
              <div class="md-border d-none d-md-block"></div> 
              <b-row>
                <b-col class="mb-4" md="6" v-for="program in programs.filter(x => !x.Ineligible  && x.ShowInCommonApplication && x.ProgramCategory != categoryView)" :key="program.ProgramId">
                  <a :href="program.ProgramPageUrl">
                    <span class="program-name">{{program.Name}}</span>
                    <span class="learn-more">Learn More <i class="fas fa-chevron-circle-right"></i></span>
                  </a>
                  <p>{{program.ProgramShortDescription}}</p>
                </b-col>
              </b-row>     
            </b-container>
            <div class="questions-headline pb-5" style="background: none;">
            <div class="container">
                    <a target="_blank" :href="commonAppUrl">
                        <h2 class="section-headline" style="margin: 0;">Apply Now on First Five SC</h2>
                        <p>Apply now for all the programs above in one place.</p>


                        <div class="circle-button button green-button">
                            <i class="fas fa-chevron-right"></i>
                        </div>
                  
                    </a>
            </div>
        </div>
          </div>
          <div v-if="programs.filter(x => !x.Ineligible && !x.ShowInCommonApplication && x.ProgramCategory != categoryView).length > 0">
            <h3 class="text-center pt-5">Based on the information you entered, <br/> your child may also be eligible for the following programs:</h3>
          <p class="text-center">For information on how to apply for these programs click "learn more" under each program.</p>
            <b-container>
              <div class="md-border d-none d-md-block"></div> 
              <b-row >
                <b-col class="mb-4" md="6" v-for="program in programs.filter(x => !x.Ineligible  && !x.ShowInCommonApplication && x.ProgramCategory != categoryView)" :key="program.ProgramId">
                  <a :href="program.ProgramPageUrl">
                    <span class="program-name">{{program.Name}}</span>
                    <span class="learn-more">Learn More <i class="fas fa-chevron-circle-right"></i></span>
                  </a>
                  <p>{{program.ProgramShortDescription}}</p>
                </b-col>
              </b-row>
            </b-container>
          </div>
        </div>
      </section>
      <section style="background:white;" class="programs-services py-2" v-else-if="anyEligible && !categoryView && programView">
        <div v-if="programs.filter(x => !x.Ineligible && x.ProgramId == programView).length > 0">
          <h3 class="text-center pb-5">Based on the information you entered, your child may be eligible for {{programs.filter(x => x.ProgramId == programView)[0].Name}}</h3>
          <b-container>
          <div class="md-border d-none d-md-block"></div>
          <b-row>
            <b-col class="mb-4" md="6" v-for="program in programs.filter(x => !x.Ineligible && x.ProgramId == programView)" :key="program.ProgramId">
              <a :href="program.ProgramPageUrl">
                <span class="program-name">{{program.Name}}</span>
                <span class="learn-more">Learn More <i class="fas fa-chevron-circle-right"></i></span>
              </a>
              <p>{{program.ProgramShortDescription}}</p>
            </b-col>
          </b-row>
        </b-container>
        <b-container class="text-center" v-if="programs.filter(x => !x.Ineligible && x.ProgramId == programView && x.ShowInCommonApplication).length > 0">
          <div class="questions-headline pb-5" style="background: none;">
            <div class="container">
                    <a target="_blank" :href="commonAppUrl">
                        <h2 class="section-headline" style="margin: 0;">Apply Now on First Five SC</h2>
                        <p>Apply now for all the programs above in one place.</p>


                        <div class="circle-button button green-button">
                            <i class="fas fa-chevron-right"></i>
                        </div>
                  
                    </a>
            </div>
        </div>
        </b-container>
        </div> 
        <div v-else>
          <h3 class="text-center pb-5">Based on the information you entered, you may not be eligible for {{programs.filter(x => x.ProgramId == programView)[0].Name}}</h3>
        </div>
        <div v-if="programs.filter(x => !x.Ineligible && x.ProgramId != programView).length > 0">
          <div v-if="programs.filter(x => !x.Ineligible && x.ShowInCommonApplication && x.ProgramId != programView).length > 0">
            <h3 class="text-center pb-5">Based on the information you entered, your child may be eligible for the following 
            programs that you can <a target="_blank" :href="commonAppUrl">apply</a> for on First Five SC:</h3>
            <b-container>
              <div class="md-border d-none d-md-block"></div> 
              <b-row>
                <b-col class="mb-4" md="6" v-for="program in programs.filter(x => !x.Ineligible  && x.ShowInCommonApplication && x.ProgramId != programView)" :key="program.ProgramId">
                  <a :href="program.ProgramPageUrl">
                    <span class="program-name">{{program.Name}}</span>
                    <span class="learn-more">Learn More <i class="fas fa-chevron-circle-right"></i></span>
                  </a>
                  <p>{{program.ProgramShortDescription}}</p>
                </b-col>
              </b-row>     
            </b-container>
            <div class="questions-headline pb-5" style="background: none;">
            <div class="container">
                    <a target="_blank" :href="commonAppUrl">
                        <h2 class="section-headline" style="margin: 0;">Apply Now on First Five SC</h2>
                        <p>Apply now for all the programs above in one place.</p>


                        <div class="circle-button button green-button">
                            <i class="fas fa-chevron-right"></i>
                        </div>
                  
                    </a>
            </div>
        </div>
          </div>
          <div v-if="programs.filter(x => !x.Ineligible && !x.ShowInCommonApplication && x.ProgramId != programView).length > 0">
            <h3 class="text-center pt-5">Based on the information you entered, <br/> your child may also be eligible for the following programs:</h3>
          <p class="text-center">For information on how to apply for these programs click "learn more" under each program.</p>
            <b-container>
              <div class="md-border d-none d-md-block"></div> 
              <b-row >
                <b-col class="mb-4" md="6" v-for="program in programs.filter(x => !x.Ineligible  && !x.ShowInCommonApplication && x.ProgramId != programView)" :key="program.ProgramId">
                  <a :href="program.ProgramPageUrl">
                    <span class="program-name">{{program.Name}}</span>
                    <span class="learn-more">Learn More <i class="fas fa-chevron-circle-right"></i></span>
                  </a>
                  <p>{{program.ProgramShortDescription}}</p>
                </b-col>
              </b-row>
            </b-container>
          </div>
        </div>
      </section>
      <section class="programs-services py-2" style="background: white;" v-else-if="!anyEligible">
          <h3 class="pb-1" v-if="!leadExpired">
              Based on the information you provided, you may not be eligible for programs and services included on First Five SC. Please check your information and try again, or contact the programs and services you’re interested in to find out more.
          </h3>
          <h3 class="pb-1" v-else>
            Your information has expired, please complete the eligibility screener again
          </h3>
          <p>
              <a href="/need-more-help/"><em>Need More Help?</em></a> Through information and referral, care coordination, and connection to resources, our partners can help guide you and provide local support for you and your family.
          </p>
          <p>
              Use <a href="https://scparents.org/" target="_blank">scParents.org</a> to search and connect to local organizations providing free or reduced-cost services for families with children of all ages. 
          </p>
      </section>
      <section style="background:white;" class="programs-services py-5">
        <b-container>
          <b-row>
            <b-col md="12">
              <div v-if="anyEligible">
                <a class="button mint-button" v-if="emailSent == 'False'" @click="emailResults">Email Me My Results</a>
                <h4 v-else>
                  Please check your email for your results
                </h4>
              </div>
            </b-col>
            <b-col md="6">
              <a class="button" @click="completeAgain">Complete for another child</a>
            </b-col>
            <b-col md="6">
              <a class="button red-button" @click="startOver">Start Over</a>
            </b-col>
            <b-col class="mb-4" md="12">
              <p>
                *Final eligibility is determined by individual programs based on their policies and procedures.  <a href="/privacy-policy">View our disclaimer</a> | <a href="/feedback">Report incorrect information</a>
              </p>
            </b-col>
          </b-row>
        </b-container>
      </section>
      <section style="background: #ceefff;color: #203962;" class="programs-services py-4 mb-3" v-if="isFourOrFive">
        <h3 class="text-center">Looks like your child will soon be ready for kindergarten! You can find kindergarten transition tips under the <a href="/learn#GettingReadyforKindergarten" target="_blank">Learn tab</a></h3>
      </section>
    </div>
    <b-modal id="bv-modal-only-sc-address" hide-footer centered>
        <template #modal-title> Only South Carolina Addresses! </template>
        <div class="d-block">
         <p>First Five SC only works with South Carolina addresses!</p>
         <p>If your moving to South Carolina, try finding the address of a landmark near where you would like to move.</p>
         <p>The SC statehouse is 1100 Gervais St, Columbia, SC 29201</p>

        </div>
        <b-button
          class="mt-3"
          block
          @click="$bvModal.hide('bv-modal-only-sc-address')"
          variant="success"
          >OK</b-button
        >
      </b-modal>
  </b-container>
</template>

<script>
import VueAutoComplete from "vue-google-autocomplete";
import CurrencyInput from "./CurrencyInput.vue"
export default {
  components: { "vue-google-autocomplete": VueAutoComplete, CurrencyInput },
  props: {
    commonAppUrl: String
  },
  data() {
    return {
      leadId: null,
      source: null,
      previousComplete: false,
      categoryView: null,
      programView: null,
      programs: [],
      criteria: [],
      selectedCriteria: [],
      showScreener: true,
      anyEligible: false,
      leadExpired: false,
      isFourOrFive: false,
      textConsent: false,
      emailSent: "False",
      name: "",
      email: "",
      phone: "",
      hearSelected: "",
      hearOptions: [
        { text: 'Family/Friend', value: 'family-friend'},
        { text: 'Google Search', value: 'google'},
        { text: 'Social Media', value: 'social'},   
        { text: 'Radio', value: 'radio'},
        { text: 'Sign/Poster/Flyer', value: 'sign'},
        { text: 'Other', value: 'other'}
      ],
      currencyOptions: {
                          locale: undefined,
                          currency: 'USD',
                          currencyDisplay: 'symbol',
                          valueRange: undefined,
                          precision: 2,
                          hideCurrencySymbolOnFocus: false,
                          hideGroupingSeparatorOnFocus: false,
                          hideNegligibleDecimalDigitsOnFocus: false,
                          autoDecimalDigits: true,
                          exportValueAsInteger: false,
                          autoSign: true,
                          useGrouping: true
                        },
      hearOther: "",
      address: "",
      addressString: "",
      addressInvalid: false,
      apartment: "",
      address_school_district: "",
      birthday: new Date(),
      current_step: 1,
      max_step: 5,
      steps: ["Contact Info", "Child's Birthday", "Address", "Additional Criteria", "Income"],
      birthdayMonth: null,
      birthdayYear: null,
      birthdayDay: null,
      invalidBirthDate: false,
      peopleInHousehold: 0,
      people_in_house_options: ["2", "3", "4", "5", "6", "7", "8"],
      income: 0.0,
      birthday_months: [
        { text: "Month", value: null },
        { text: "January", value: "01" },
        { text: "February", value: "02" },
        { text: "March", value: "03" },
        { text: "April", value: "04" },
        { text: "May", value: "05" },
        { text: "June", value: "06" },
        { text: "July", value: "07" },
        { text: "August", value: "08" },
        { text: "September", value: "09" },
        { text: "October", value: "10" },
        { text: "November", value: "11" },
        { text: "December", value: "12" },
      ],
      birthday_days: [
        { text: "Day", value: null },
        { text: "1", value: "1" },
        { text: "2", value: "2" },
        { text: "3", value: "3" },
        { text: "4", value: "4" },
        { text: "5", value: "5" },
        { text: "6", value: "6" },
        { text: "7", value: "7" },
        { text: "8", value: "8" },
        { text: "9", value: "9" },
        { text: "10", value: "10" },
        { text: "11", value: "11" },
        { text: "12", value: "12" },
        { text: "13", value: "13" },
        { text: "14", value: "14" },
        { text: "15", value: "15" },
        { text: "16", value: "16" },
        { text: "17", value: "17" },
        { text: "18", value: "18" },
        { text: "19", value: "19" },
        { text: "20", value: "20" },
        { text: "21", value: "21" },
        { text: "22", value: "22" },
        { text: "23", value: "23" },
        { text: "24", value: "24" },
        { text: "25", value: "25" },
        { text: "26", value: "26" },
        { text: "27", value: "27" },
        { text: "28", value: "28" },
        { text: "29", value: "29" },
        { text: "30", value: "30" },
        { text: "31", value: "31" },
      ],
      birthday_years: [
        { text: "Year", value: null },
        { text: "2025", value: "2025"},
        { text: "2024", value: "2024"},
        { text: "2023", value: "2023"},
        { text: "2022", value: "2022"},
        { text: "2021", value: "2021" },
        { text: "2020", value: "2020" },
        { text: "2019", value: "2019" },
        { text: "2018", value: "2018" },
        { text: "2017", value: "2017" },
        { text: "2016", value: "2016" },
        { text: "2015", value: "2015" },
        { text: "2014", value: "2014" },
        { text: "2013", value: "2013" },
        { text: "2012", value: "2012" },
        { text: "2011", value: "2011" },
        { text: "2010", value: "2010" }
      ],
      rules: {
        required: (value) => !!value || "Required.",
        counter: (value) => value.length <= 20 || "Max 20 characters",
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
      },
      districts: {
          "abbeville":"Abbeville" ,
          "aiken":"Aiken" ,
          "allendale":"Allendale" ,
          "anderson-1":"Anderson 1" ,
          "anderson-2":"Anderson 2" ,
          "anderson-3":"Anderson 3" ,
          "anderson-4": "Anderson 4" ,
          "anderson-5": "Anderson 5" ,
          "bamberg-1":"Bamberg 1" ,
          "bamberg-2" : "Bamberg 2" ,
          "barnwell-19":"Barnwell 19" ,
          "barnwell-29":"Barnwell 29",
          "barnwell-45":"Barnwell 45",
          "beaufort":"Beaufort",
          "berkeley":"Berkeley",
          "calhoun":"Calhoun",
          "charleston":"Charleston",
          "cherokee":"Cherokee",
          "chester":"Chester",
          "chesterfield":"Chesterfield",
          "clarendon-1":"Clarendon 1",
          "clarendon-2":"Clarendon 2",
          "clarendon-3":"Clarendon 3",
          "colleton":"Colleton",
          "darlington":"Darlington",
          "dillon-3":"Dillon 3",
          "dillon-4":"Dillon 4",
          "dorchester-2":"Dorchester 2",
          "dorchester-4":"Dorchester 4",
          "edgefield":"Edgefield",
          "fairfield":"Fairfield",
          "florence-1":"Florence 1",
          "florence-2":"Florence 2",
          "florence-3":"Florence 3",
          "florence-4":"Florence 4",
          "florence-5":"Florence 5",
          "georgetown":"Georgetown",
          "greenville":"Greenville",
          "greenwood-50":"Greenwood 50",
          "greenwood-51":"Greenwood 51",
          "greenwood-52":"Greenwood 52",
          "hampton-1":"Hampton 1",
          "hampton-2":"Hampton 2",
          "horry":"Horry",
          "jasper":"Jasper",
          "kershaw":"Kershaw",
          "lancaster":"Lancaster",
          "laurens-55":"Laurens 55",
          "laurens-56":"Laurens 56",
          "lee":"Lee",
          "lexington-1":"Lexington 1",
          "lexington-2":"Lexington 2",
          "lexington-3":"Lexington 3",
          "lexington-4":"Lexington 4",
          "lexingtonrichland-5":"Lex-Rich 5",
          "marion":"Marion",
          "marlboro":"Marlboro",
          "mccormick":"McCormick",
          "newberry":"Newberry",
          "oconee":"Oconee",
          "orangeburg":"Orangeburg",
          "pickens":"Pickens",
          "richland-1":"Richland 1",
          "richland-2":"Richland 2",
          "saluda":"Saluda",
          "spartanburg-1":"Spartanburg 1",
          "spartanburg-2":"Spartanburg 2",
          "spartanburg-3":"Spartanburg 3",
          "spartanburg-4":"Spartanburg 4",
          "spartanburg-5":"Spartanburg 5",
          "spartanburg-6":"Spartanburg 6",
          "spartanburg-7":"Spartanburg 7",
          "sumter":"Sumter",
          "union":"Union",
          "williamsburg": "Williamsburg",
          "york-1":"York 1",
          "york-2":"York 2",
          "york-3":"York 3",
          "york-4":"York 4"
        }
    };
  },
  mounted: function () {
    //add an if to check if query string contains category, if so call getcriteriabycategory and pass the category
    //if query string contains program, call getcriteriabyprogram and pass the program
    //otherwise return all

    let uri = window.location.search.substring(1);
    let params = new URLSearchParams(uri);

    this.categoryView = params.get("category");
    this.programView = params.get("program");
    this.leadId = params.get("lead");
    this.source = params.get("source");

    if(localStorage.getItem("name") != null){
      this.name = localStorage.getItem("name");
    }

    if(localStorage.getItem("email") != null){
      this.email = localStorage.getItem("email");
    }

    if(localStorage.getItem("hearSelected") != null){
      this.hearSelected = localStorage.getItem("hearSelected");
    }

    if(localStorage.getItem("hearOther") != null){
      this.hearOther = localStorage.getItem("hearOther");
    }

    if(localStorage.getItem("phone") != null){
      this.phone = localStorage.getItem("phone");
    }

    if(localStorage.getItem("address") != null){
          this.address = JSON.parse(localStorage.getItem("address"));
    }

    if(localStorage.getItem("apartment") != null){
      this.apartment = localStorage.getItem("apartment");
    }

    if(localStorage.getItem("birthdayDay") != null){
      this.birthdayDay = localStorage.getItem("birthdayDay");
    }

    if(localStorage.getItem("birthdayMonth") != null){
      this.birthdayMonth = localStorage.getItem("birthdayMonth");
    }

    if(localStorage.getItem("birthdayYear") != null){
      this.birthdayYear = localStorage.getItem("birthdayYear");
    }

    if(localStorage.getItem("isFourOrFive") != null){
      this.isFourOrFive = localStorage.getItem("isFourOrFive");
    }

    if(localStorage.getItem("selectedCriteria") != null){
      this.selectedCriteria = JSON.parse(localStorage.getItem("selectedCriteria"));
    }

    if(localStorage.getItem("peopleInHousehold") != null){
      this.peopleInHousehold = JSON.parse(localStorage.getItem("peopleInHousehold"));
    }

    if(localStorage.getItem("income") != null){
      this.income = JSON.parse(localStorage.getItem("income"));
    }
    else{
      this.income = null;
    }

    
    fetch("/umbraco/api/programs/getallcriteria")
    .then((response) => response.json())
    .then((data) => (this.criteria = data));
    
    
    
    if(this.leadId){
      if(this.source){
        fetch('/umbraco/api/leadapi/geteligibleprograms?LeadId=' + this.leadId)
        .then((response) => response.json())
        .then((data) => {
            this.programs = data.Programs;
            this.anyEligible = data.AnyEligible;
            this.leadExpired = data.LeadExpired;
            this.$cookie.set('screenerCompleted', data.ScreenerCompleted, {domain: 'first5sc.org'});
            this.$cookie.set('screenerAddress', JSON.stringify(data.ScreenerAddress), {domain: 'first5sc.org'});
            this.$cookie.set('screenerDistrict', data.ScreenerDistrict, {domain: 'first5sc.org'});
            this.$cookie.set('screenerPrograms', data.ScreenerPrograms, {domain: 'first5sc.org'});
        });
        this.showScreener = false;
      }
      else if(localStorage.getItem("programs") != null){
        this.programs = JSON.parse(localStorage.getItem("programs"));
        this.showScreener = false;
        if(localStorage.getItem("anyEligible") != null){
          this.anyEligible = localStorage.getItem("anyEligible");
        }
      }
      else{
        fetch("/umbraco/api/programs/getallprograms")
        .then((response) => response.json())
        .then((data) => (this.programs = data));
      }
    }
    else{
      fetch("/umbraco/api/programs/getallprograms")
        .then((response) => response.json())
        .then((data) => (this.programs = data));
    }
  },
  computed: {
    progress: function () {
      return Math.round(100 / this.max_step) * this.current_step;
    },
    getSavedAddress: function(){
        //Retrieving address from local storage, refs only works when item is displayed;

        if(this.address){
          var addressString = this.address.street_number + ' ' + this.address.route + ', ' + this.address.locality + ', ' + this.address.administrative_area_level_1 + ' ' + this.address.postal_code;
          return addressString;
        }
        

        return '';
    }
  },
  methods: {
    contactInfoSubmit(event) {
      event.preventDefault();
      localStorage.setItem("email", this.email);
      localStorage.setItem("name", this.name);
      localStorage.setItem("phone", this.phone);
      localStorage.setItem("hearSelected", this.hearSelected);
      localStorage.setItem("hearOther", this.hearOther);
      var lead;
      if(this.leadId){
        lead = {
          "LeadId": this.leadId,
          "ParentName": this.name,
          "Email" : this.email,
          "Phone" : this.phone,
          "ReferralType": this.hearSelected,
          "ReferralNote": this.hearOther
        };
      }
      else{
        lead = {
          "ParentName": this.name,
          "Email" : this.email,
          "Phone" : this.phone,
          "ReferralType": this.hearSelected,
          "ReferralNote": this.hearOther
        };
      }

      

      this.postLead(lead).then(() => {
        this.subscribeKlaviyo(false);
      });
      
      this.$announcer.polite("Contact Information Submitted. New Content Loaded'");
      window.scrollTo(0,0);
      this.current_step++;
    },
    birthdaySubmit(event) {
      event.preventDefault();
      
      this.invalidBirthDate = false;
      var birthdayDayNew = this.birthdayDay;
      if (this.birthdayDay.length < 2) {
        birthdayDayNew = "0" + this.birthdayDay;
      }
      var birthdayString =
        this.birthdayYear +
        "-" +
        this.birthdayMonth +
        "-" +
        birthdayDayNew +
        "T00:00:00.000Z";
      var birthday = Date.parse(birthdayString);

      //check if valid date
      if (isNaN(birthday)) {
        this.invalidBirthDate = true;
        return false;
      }

      birthday = new Date(birthdayString);

      if (birthday.getUTCMonth() != this.birthdayMonth - 1) {
        this.invalidBirthDate = true;
        return false;
      }

      this.birthday = birthday;
      localStorage.setItem("birthdayMonth", this.birthdayMonth);
      localStorage.setItem("birthdayDay", this.birthdayDay);
      localStorage.setItem("birthdayYear", this.birthdayYear);
      this.checkEligibilityBirthday();
      window.scrollTo(0,0);
      this.$announcer.polite('Birthday Submitted. New Content Loaded');
      this.current_step++;
    },
    addressSubmit: function (event) {
      event.preventDefault();
      if (this.address) {
        var that = this;
        var map = new window.google.maps.Map(
          document.getElementById("districtMap"),
          {
            zoom: 6,
            center: { lat: 34, lng: -81 },
          }
        );
        map.data.loadGeoJson(
          "/dist/sc_school_districts.json",
          {},
          function (features) {
            var found = false;
            for (var i = 0; i < features.length; i++) {
              var feature = features[i];
              var gaGeom = feature.getGeometry();
              var poly = new window.google.maps.Polygon({
                paths: gaGeom.getAt(0).getArray(),
                map: map,
                clickable: false,
              });
              var point = new window.google.maps.LatLng(
                that.address.latitude,
                that.address.longitude
              );
              var inside = window.google.maps.geometry.poly.containsLocation(
                point,
                poly
              );

              if (inside) {
                that.address_school_district = feature.getProperty("slug");
                found = true;
                break;
              }
            }

            if (found) {
              window.scrollTo(0, 0);
              that.checkEligibilityLocation();
              

              if (that.address) {
                that.addressString = that.address.street_number + ' ' + that.address.route + ', ' + that.address.locality + ', ' + that.address.administrative_area_level_1 + ' ' + that.address.postal_code;
              }
              localStorage.setItem("address",JSON.stringify(that.address));
              localStorage.setItem("apartment", that.apartment);

              var lead;
              if(that.leadId){
                lead = {
                  "ParentName": that.name,
                  "Email" : that.email,
                  "Phone" : that.phone,
                  "ReferralType": that.hearSelected,
                  "ReferralNote": that.hearOther,
                  "LeadId": that.leadId,
                  "Address": that.addressString,
                  "ApartmentNumber": that.apartment,
                  "County": that.address.administrative_area_level_2,
                  "SchoolDistrict": that.districts[that.address_school_district]
                };
              }
              else{
                lead = {
                  "ParentName": that.name,
                  "Email" : that.email,
                  "Phone" : that.phone,
                  "ReferralType": that.hearSelected,
                  "ReferralNote": that.hearOther,
                  "Address": that.addressString,
                  "ApartmentNumber": that.apartment,
                  "County": that.address.administrative_area_level_2,
                  "SchoolDistrict": that.districts[that.address_school_district]
                };
              }

              that.postLead(lead);

              window.scrollTo(0,0);
              that.$announcer.polite('Address Information Submitted. New Content Loaded');
              that.current_step++;
            }
            else {
              console.log('address not in SC - show message');
              that.$bvModal.show('bv-modal-only-sc-address')
            }
          }
        );
      } 
      else {
        console.log('address empty');
       // this.invalidAddress = true;
        return false;
      }
    },
    onClickBack: function () {
      window.scrollTo(0,0);
      this.current_step--;
    },
    getAddressData(addressData, placeResultData, id) {
      console.log(id, placeResultData);
      this.address = addressData;
    },
    addressInputChanged: function(){
      this.$announcer.polite("Please select an address using the arrow keys");
    },
    specialCircumstancesSubmit: function(event) {
        event.preventDefault();
        localStorage.setItem("selectedCriteria", JSON.stringify(this.selectedCriteria));
        window.scrollTo(0,0);
        this.current_step++;
    },
    incomeSubmit: function(event) {
        event.preventDefault();
        localStorage.setItem("peopleInHousehold", JSON.stringify(this.peopleInHousehold));
        localStorage.setItem("income", JSON.stringify(this.income));
        window.scrollTo(0,0);
        this.checkEligibilityIncome();
        this.checkEligibilitySpecial();
        this.goToResults();
        this.showScreener = false;
    },
    checkEligibilityBirthday: function(){
        //check birthdays
        var that = this;

        var today = new Date();
        var isPrenatal = false;
        if(that.birthday > today){
          isPrenatal = true;
        }

        for(var i = 0; i < that.programs.length; i++){
            that.programs[i].IneligibleAge = false;
            var dateToCheck = new Date(that.programs[i].Age.AgeOfDate);
            var minAge = that.programs[i].Age.MinimumAge;
            var maxAge = that.programs[i].Age.MaximumAge;
            var age = this.ageOnDate(that.birthday, dateToCheck);
            if(!isPrenatal){
              if(minAge <= age && age <= maxAge){
                  that.programs[i].Ineligible = false;
              }
              else{
                  that.programs[i].IneligibleAge = true;
              }
            }
            else{
              if(that.programs[i].Age.IncludesPrenatal){
                that.programs[i].Ineligible = false;
              }
              else{
                that.programs[i].IneligibleAge = true;
              }
            }
            
        }

        //check if they are 4 or 5
        var checkAge = this.ageOnDate(that.birthday, today);
        if(48 <= checkAge && checkAge <= 71){
          that.isFourOrFive = true;
        }
        else{
          that.isFourOrFive = false;
        }
        localStorage.setItem("isFourOrFive", that.isFourOrFive);
        
    },
    ageOnDate: function(birthday, dateToCheck){
        /*var ageDifMs = dateToCheck - birthday;
        var ageDate = new Date(ageDifMs); // miliseconds from epoch
        return Math.abs(ageDate.getUTCFullYear() - 1970);*/
        var checkDate = new Date(dateToCheck);
        var birthDate = new Date(birthday);
        var age = checkDate.getFullYear() - birthDate.getFullYear();
        var m = checkDate.getMonth() - birthDate.getMonth();
        age = age * 12 + m;
        if(checkDate.getMonth() == birthDate.getMonth()){
          if(checkDate.getDate() <= birthDate.getDate()){
            age--;
          }
        }
        return age;
    },
    checkEligibilityLocation: function(){
        var that = this;
        if(that.address){
          var county = that.address.administrative_area_level_2;
          var postal = that.address.postal_code;
          var schoolDistrict = null;
          if(that.address_school_district){
            schoolDistrict = that.districts[that.address_school_district];
          }
          for(var i = 0; i < that.programs.length; i++){
            that.programs[i].CountyIneligible = false;
            that.programs[i].ZipIneligible = false;
            that.programs[i].SchoolDistrictIneligible = false;
            if(county){
              if(that.programs[i].Counties && that.programs[i].Counties.length > 0){
                var matchingCounties = that.programs[i].Counties.filter(x => x == county);
                if(matchingCounties.length == 0){
                  that.programs[i].CountyIneligible = true;
                }
              }
            }
            if(schoolDistrict){
              if(that.programs[i].Districts && that.programs[i].Districts.length > 0){
                var matchingDistricts = that.programs[i].Districts.filter(x => x == schoolDistrict);
                if(matchingDistricts.length == 0){
                  that.programs[i].SchoolDistrictIneligible = true;
                }
              }
            }
            if(postal){
              if(that.programs[i].ZipCodes && that.programs[i].ZipCodes.length > 0){
                var matchingZips = that.programs[i].ZipCodes.filter(x => x == postal);
                if(matchingZips.length == 0){
                  that.programs[i].ZipIneligible = true;
                }
              }
            }

          }
          
        }
    },
    checkEligibilitySpecial: function(){
        var that = this;
        for(var i = 0; i < that.programs.length; i++){
            that.programs[i].IneligibleSpecial = false;
            that.programs[i].OverrideIncome = false;
            
            var totalReq = 0;

            if(that.programs[i].IncomeAsRequired){      
              if(that.programs[i].IneligibleIncome){
                that.programs[i].IneligibleIncome = false;
              }
              else{
                totalReq++;
              }
            }

            for(var j = 0; j < that.programs[i].Criteria.length; j++){
                var criteriaId = that.programs[i].Criteria[j].CriteriaId;
                var criteriaType = that.programs[i].Criteria[j].Type;
                if(that.selectedCriteria.includes(criteriaId)){
                    if(criteriaType == "Override Income"){
                        that.programs[i].OverrideIncome = true;
                    }
                    else if(criteriaType == "Required"){
                      totalReq++;
                    }
                }
                else {
                    if(criteriaType == "Required" && that.programs[i].MinimumRequired == 0){
                        if(that.programs[i].ProgramId == 1088){
                          console.log('missing id: ' + criteriaId);
                        }
                        that.programs[i].IneligibleSpecial = true;
                    }

                    if(criteriaType == "Absolute"){
                      that.programs[i].IneligibleSpecial = true;
                    }
                }
            }

            if(that.programs[i].MinimumRequired > 0 && that.programs[i].MinimumRequired > totalReq){
              if(that.programs[i].ProgramId == 1088){
                console.log("head start ineligible special. min req: " + that.programs[i].MinimumRequired + " totalReq hit: " + totalReq);
              }
              that.programs[i].IneligibleSpecial = true;
            }
        }
    },
    checkEligibilityIncome: function(){
        var that = this;
        for(var i = 0; i < that.programs.length; i++){
            that.programs[i].IneligibleIncome = false;
            
            var income = that.programs[i].Incomes.filter(function(j){
                return j.PeopleInHousehold == that.peopleInHousehold;
            });
            if(income.length > 0){
              if(that.income > income[0].MaximumIncome){
                  that.programs[i].IneligibleIncome = true;
              }
            }
            
        }
    },
    subscribeKlaviyo: function(completed) {
      console.log('subscribing', this.leadId, this.textConsent);
      var subscriptionObject;
      if(this.leadId){
        subscriptionObject = {
          "LeadId" : this.leadId,
          "TextConsented" : this.textConsent,
          "Completed" : completed
        };
        
        fetch('/umbraco/api/leadapi/postklaviyosubscription',
        {
          method: 'POST',
          headers: 
            {
              'Content-Type': 'application/json'
            },
          body: JSON.stringify(subscriptionObject)
        })
        .then(response => response.json())
        .then(data =>{
          console.log('klaviyo response', data);
        });

      }
    },
    goToResults: function(){
        //Final eligibilty check before showing the results
        var that = this;
        var eligibleList = '';

        console.log(that.programs);
        console.log(that.selectedCriteria);

        for(var i = 0; i < that.programs.length; i++){
            if(that.programs[i].CountyIneligible || that.programs[i].SchoolDistrictIneligible || that.programs[i].ZipIneligible || that.programs[i].IneligibleAge || 
                          that.programs[i].IneligibleSpecial || (that.programs[i].IneligibleIncome && !that.programs[i].OverrideIncome)){
                that.programs[i].Ineligible = true;
            }
            else{
              that.anyEligible = true;
              eligibleList += that.programs[i].ProgramId + '|';
            }
        }

        //this is where we will save the lead to the db and set local storage item for use on results page
        eligibleList = eligibleList.slice(0, -1);
        var lead;
        if(that.leadId){
          lead = {
            "ParentName": that.name,
            "Email" : that.email,
            "Phone" : that.phone,
            "ReferralType": that.hearSelected,
            "ReferralNote": that.hearOther,
            "LeadId": that.leadId,
            "Address": that.addressString,
            "ApartmentNumber": that.apartment,
            "County": that.address.administrative_area_level_2,
            "SchoolDistrict": that.districts[that.address_school_district],
            "EligiblePrograms": eligibleList
          };
        }
        else{
          lead = {
            "ParentName": that.name,
            "Email" : that.email,
            "Phone" : that.phone,
            "ReferralType": that.hearSelected,
            "ReferralNote": that.hearOther,
            "Address": that.addressString,
            "ApartmentNumber": that.apartment,
            "County": that.address.administrative_area_level_2,
            "SchoolDistrict": that.districts[that.address_school_district],
            "EligiblePrograms": eligibleList
          };
        }

        that.postLead(lead).then(() => {
          that.subscribeKlaviyo(true);
        });
        localStorage.setItem("programs", JSON.stringify(that.programs));
        localStorage.setItem("anyEligible", that.anyEligible);
        localStorage.setItem("leadId", that.leadId);
        var searchParams = new URLSearchParams(window.location.search);
        searchParams.set("lead", that.leadId);
        var newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
        history.pushState(null, '', newRelativePathQuery);
        this.$announcer.polite('Application submitted. Your results loaded.');


        var countyChange = false;
        //check if county has changed
        if(this.$cookie.get('screenerAddress'))
        {
          var oldAddress = JSON.parse(this.$cookie.get('screenerAddress'));
          if (oldAddress.administrative_area_level_2 != that.address.administrative_area_level_2)
          {
            console.log('county changed, remove old programs');
            countyChange = true;
            this.$cookie.set('screenerCountyChanged', true, {domain: 'first5sc.org'});
          }
        }


        this.$cookie.set('screenerCompleted', true, {domain: 'first5sc.org'});
        this.$cookie.set('screenerName', that.name, {domain: 'first5sc.org'});
        this.$cookie.set('screenerEmail', that.email, {domain: 'first5sc.org'});
        this.$cookie.set('screenerPhone', that.phone, {domain: 'first5sc.org'});
        this.$cookie.set('screenerAddress', JSON.stringify(that.address), {domain: 'first5sc.org'});
        this.$cookie.set('screenerAptNumber', that.apartment, {domain: 'first5sc.org'});
        this.$cookie.set('screenerDistrict', that.districts[that.address_school_district], {domain: 'first5sc.org'});

        if(this.$cookie.get('screenerPrograms') && !countyChange){
          var existingPrograms = this.$cookie.get('screenerPrograms').split('|');
          var currentPrograms = eligibleList.split('|');
          var newPrograms = existingPrograms.concat(currentPrograms.filter((item) => existingPrograms.indexOf(item) < 0));
          this.$cookie.set('screenerPrograms', newPrograms.join('|'), {domain: 'first5sc.org'});
        }
        else{
          this.$cookie.set('screenerPrograms', eligibleList, {domain: 'first5sc.org'});
        }
    },
    postLead: function(lead){
      var that = this;
      return fetch('/umbraco/api/leadapi/postlead',
      {
        method: 'POST',
        headers: 
          {
            'Content-Type': 'application/json'
          },
        body: JSON.stringify(lead)
      })
      .then(response => response.json())
      .then(data =>{
        that.leadId = data;
      });
    },
    emailResults: function(){
      var that = this;
      fetch("/send-email/" + that.leadId)
      .then((data) => (that.emailSent = data));
    },
    completeAgain: function() {
      localStorage.removeItem("programs");
      localStorage.removeItem("anyEligible");
      localStorage.removeItem("leadId");
      localStorage.removeItem("birthdayMonth");
      localStorage.removeItem("birthdayDay");
      localStorage.removeItem("birthdayYear");
      let uri = window.location.search.substring(1);
      let params = new URLSearchParams(uri);
      let source = params.get("source");
      if(source){
        params.delete("source");
      }
      let lead = params.get("lead");
      if(lead){
        params.delete("lead");
        var newRelativePathQuery = window.location.pathname + '?' + params.toString();
        history.pushState(null, '', newRelativePathQuery);
        window.location.reload();
      }
    },
    startOver: function() {
      localStorage.clear();
      if(this.$session.exists('screenerCompleted')){
        this.$session.remove('screenerCompleted');
        this.$session.remove('screenerPrograms');
      }
      let uri = window.location.search.substring(1);
      let params = new URLSearchParams(uri);
      let source = params.get("source");
      if(source){
        params.delete("source");
      }
      let lead = params.get("lead");
      if(lead){
        params.delete("lead");
        var newRelativePathQuery = window.location.pathname + '?' + params.toString();
        history.pushState(null, '', newRelativePathQuery);
        window.location.reload();
      }
    }
  },
};
</script>
